import "./Footer.component.css";
export default function Footer() {
  return (
    <div className="footer">
      <p>&copy; 2021@wahyu</p>
    </div>
  )
}